import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { LoaderServiceService } from '../loader-service.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'app-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrl: './spinner-loader.component.scss',
  imports: [CommonModule, MatProgressSpinnerModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SpinnerLoaderComponent {
  [key: string]: any;
  constructor() {}

  ngOnInit() {}
}
